import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import FiltersProvider from 'src/components/filters/FiltersProvider/FiltersProvider.vue';
import QAResumeListPage from 'src/components/resumes/QAResumeListPage/QAResumeListPage.vue';
import VisitorProvider from 'src/components/users/VisitorProvider/VisitorProvider.vue';

const models = {
  hubs: {
    title: ({ filters, title }) => filters.onlyContributedHubs ? `${title} (есть вклад)` : title,
  },
  onlyContributedHubs: {
    isSelected: () => false,
  },
  activeLastYear: {
    title: 'Активные за последний год'
  },
  locations: {
    title: ({ filters, title }) => filters.excludeLocations ? `${title} (исключить)` : title,
  },
  excludeLocations: {
    isSelected: () => false,
  },
};

const {
  isGuest,
  tabs,
  resumes,
  search,
  options,
  filtersData: dynamicOptions,
} = getSsrState();

const { filters } = search;

const app = createVueApp({
  render(h) {
    return h(VisitorProvider, { props: { visitor: { isGuest } } }, [
      h(FiltersProvider, {
        props: {
          filters,
          options,
          dynamicOptions,
          models,
        }
      }, [
        h(QAResumeListPage, {
          props: {
            tabs,
            resumes,
          }
        })
      ])
    ]);
  }
});

app.$mount('[data-resume-list]');